import { render, staticRenderFns } from "./offer-product-row.vue?vue&type=template&id=39fd692c&"
import script from "./offer-product-row.vue.ts?vue&type=script&lang=ts&"
export * from "./offer-product-row.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports